import { UserManagementService } from './userManagement.service';
import { UserManagementDelegate } from './userManagement.delegate';
import { HttpProviderFactory } from '../http/http-provider.factory';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { SpinnerService } from '../SpinnerService';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { ConfigService } from '../ConfigService';

export class UserManagementServiceFactory {
    static create(
        config: IAppConfig,
        spinnerService?: SpinnerService,
        authService?: AuthenticationService,
        configService?:ConfigService
    ): UserManagementService {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const userManagementDelegate = new UserManagementDelegate(config, httpProvider);
        return new UserManagementService(userManagementDelegate,authService,configService);
    }
}